import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SharedButton from "../../components/Shared/SharedButton";
import AccountsTable from "./AccountsTable";
import { useTranslation } from "react-i18next";
import {
  setCuurentAccountTab,
} from "../../store/slices/AcountsSlice";
import SearchField from "../../components/Shared/SearchField";
import CustomTabs from "../../components/Shared/CustomTabs";
import SharedPageHeader from "../../components/Shared/SharedPageHeader";
import { FaUniversity } from "react-icons/fa";
import useFetchData from "../../hooks/useFetchData";
import useDebounce from "../../hooks/useDebounce";

export default function AccountsMain() {
  const dispatch = useDispatch();
  const [createDialogVisible, setCreateDialogVisible] = useState(false);
  const { data, loading, executeFetch } = useFetchData()
  const [updateData, setUpdateData] = useState(null);
  const [accountData, setAccountData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const { t } = useTranslation();
  const { activeAccountsTab } = useSelector(
    (state) => state.acount,
  );
  const [activeTab, setActiveTab] = useState(activeAccountsTab ?? "Asset");
  const navigate = useNavigate();
  useEffect(() => {
    executeFetch("POST", "listAccounts", {
      account_type: activeTab,
      query: debouncedSearchQuery,
    });
  }, [executeFetch, activeTab, debouncedSearchQuery]);

  const accounts = data?.data || [];

  const filteredAccounts = useMemo(() => {
    return accounts;
  }, [accounts]);

  const tabList = [
    { name: t("Asset"), value: "Asset" },
    { name: t("Liability"), value: "Liability" },
    { name: t("Revenue"), value: "Revenue" },
    { name: t("Equity"), value: "Equity" },
    { name: t("Expense"), value: "Expense" },
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.value);
    setSearchQuery("");
    dispatch(setCuurentAccountTab(tab.value));
  };

  const accountCount = useMemo(() => {
    function countDescendants(nodes, { includeRoots = true } = {}) {
      if (!Array.isArray(nodes) || nodes.length === 0) return 0;

      let count = includeRoots ? nodes.length : 0;
      const stack = [...nodes];

      while (stack.length) {
        const node = stack.pop();
        const kids = node.children;
        if (kids && kids.length) {
          count += kids.length;
          stack.push(...kids);
        }
      }
      return count;
    }
    return countDescendants(accounts);
  }, [accounts]);

  return (
    <div>

      <SharedPageHeader
        title={t("ACCOUNTS")}
        iconSize={18}
        iconClass="!text-primary"
        Icon={FaUniversity}
      >
        <div className="flex items-center gap-2">
          <div className="flex gap-2">
            <SearchField
              placeholder={t("Search_by_Code_or_name")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              handleClearClick={() => setSearchQuery("")}
              className="w-full md:!w-[300px]"
            />
          </div>
          <SharedButton
            label={t("CreateAccount")}
            icon="pi pi-plus"
            onClick={() => navigate("/manager/accounts/create")}
            className="bg-primary !w-full primary-btn"
          />
        </div>
      </SharedPageHeader>

      <div className="yee">
        <CustomTabs
          tabs={tabList}
          activeTabIndex={tabList.findIndex((tab) => tab.value === activeTab)}
          setActiveTabIndex={(index) => handleTabClick(tabList[index])}
        />

        <div className="rounded-md h-[70vh] overflow-auto">
          <AccountsTable
            loading={loading}
            data={filteredAccounts}
            setUpdateData={setUpdateData}
            setCreateDialogVisible={setCreateDialogVisible}
            setAccountData={setAccountData}
            activeTab={activeTab}
          />
        </div>
      </div>
    </div>
  );
}
